module.exports = __webpack_public_path__ + "static/43-1ace2e20654a9e4d7d51391080534b34.png";